// Portal access roles, in ascending privilege order. Firestore rules are the
// real enforcement — these gate client-side UX only (see firestore.rules).
export const VALID_ROLES = ["lp", "chapter_director", "superAdmin"];
